var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-markdown',{attrs:{"source":_vm.source,"table-class":_vm.tableClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }